const Groupon = window.Groupon;
const { h, render } = require('preact');
const App = require('./App');
const I18n = window.I18n;
const cardUI = require('grpn-card-ui/frontend/init.js')
window.cardUI = cardUI; 
import 'preact/devtools'

const handleLandingSpinner = () => {
  let landingSpinner = document.getElementById('landing-spinner')
  if (landingSpinner)
    landingSpinner.style.display = 'none'
}

document.addEventListener('DOMContentLoaded', () => {
  Groupon.Performance.pageReady()
  handleLandingSpinner()

  if(document.getElementById('main-app'))
    render(<App />, document.getElementById('main-app'));

  if(document.getElementById('faq-app')){
    let hashHandler = function(){
      window.location.reload()
    }
    window.addEventListener("hashchange", hashHandler, false);
    render(<App/>, document.getElementById('faq-app'));
  }
});

(function () {
  //Polyfill for CustomEvent in IE
  if ( typeof window.CustomEvent === "function" ) return false;

  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
   }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();

(function(E, d, w) {
  // Polyfill for event.composedPath in IE and Edge
  if(!E.composedPath) {
    E.composedPath = function() {
      if (this.path) {
        return this.path;
      } 
    var target = this.target;
    
    this.path = [];
    while (target.parentNode !== null) {
      this.path.push(target);
      target = target.parentNode;
    }
    this.path.push(d, w);
    return this.path;
    }
  }
})(Event.prototype, document, window);
